const generateAssetURI = (fileName) => `${process.env.PUBLIC_URL}/${process.env.REACT_APP_SETUP_PATH}/${fileName}`

export { generateAssetURI }